import {
    Component,
    ElementRef,
    EventEmitter,
    inject,
    Input,
    OnInit,
    Output,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { LookupFieldResult } from '@wdx/clmi/clmi-swagger-gen';
import { ModalManagementService } from '@wdx/clmi/ui';
import {
    WdxButtonSize,
    WdxButtonStyle,
} from '@wdx/shared/components/wdx-button';
import {
    TRANSLATION_BANNER_INFO_LOOKUP,
    UTILS_ICON_DELETE,
    UTILS_ICON_SEARCH,
} from '@wdx/shared/utils';
import { BaseInputClass } from '../../../../../classes/base-input-class';
import { InfoCardSearchMode } from '../../../../../models/info-card-search-mode.model';
import { RandomStringPipe } from '../../../../../pipes/random-string.pipe';
import { InfoCardService } from '../../../../../shared/services/info-card/info-card.service';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'molecule-input-lookup-dumb',
    templateUrl: './molecule-input-lookup-dumb.component.html',
    styleUrls: ['./molecule-input-lookup-dumb.component.scss'],
    standalone: false,
})
export class MoleculeInputLookupDumbComponent
    extends BaseInputClass
    implements OnInit
{
    public infoCardService = inject(InfoCardService);
    @Input() isMulti: boolean;
    @Input() showReadout: boolean;

    @Input() lookupIsLoading: boolean;
    @Input() lookupHasError: boolean;
    @Input() lookupResults: LookupFieldResult[];
    @Input() lookupMode: string;
    @Input() set showSuggestion(val: boolean) {
        this.bannerInfo = '';
        if (val) {
            this.bannerInfo = TRANSLATION_BANNER_INFO_LOOKUP;
        }
    }
    @Input() placeholder: string;
    @Input() showNoResultsMessage: boolean;
    @Input() formData: UntypedFormGroup;

    @Output() opened = new EventEmitter();
    @Output() closed = new EventEmitter();
    @Output() searchTriggered = new EventEmitter<string>();
    @Output() blurred = new EventEmitter();
    @Output() modalRegistered = new EventEmitter<string>();
    @Output() generateDocument = new EventEmitter<string>();
    @Output() previewAvailableDocumentData =
        new EventEmitter<LookupFieldResult>();
    @Output() deleteItem = new EventEmitter<any>();

    modalId: string;
    inputName: string;
    bannerInfo: string;
    keyword: string;

    readonly InfoCardSearchMode = InfoCardSearchMode;
    readonly UTILS_ICON_SEARCH = UTILS_ICON_SEARCH;
    readonly UTILS_ICON_DELETE = UTILS_ICON_DELETE;
    readonly WdxButtonStyle = WdxButtonStyle;
    readonly WdxButtonSize = WdxButtonSize;

    public lookupResultsAsInfoCardData =
        this.infoCardService.lookupResultsAsInfoCardData.bind(
            this.infoCardService,
        );

    constructor(
        elementRef: ElementRef,
        modalManagementService: ModalManagementService,
    ) {
        super();

        this.patchInjectedItems({
            elementRef,
            modalManagementService,
        });

        this.keyword = null;
    }

    ngOnInit() {
        this.modalId = new RandomStringPipe().transform();
        this.modalRegistered.emit(this.modalId);

        this.inputName = new RandomStringPipe().transform();
    }

    valueAsString(value: any): string {
        let returnValue: string;

        if (!value) {
            return null;
        }

        if (value[0]) {
            returnValue = value.map((val) => val.name).join('; ');
        } else {
            returnValue = value.name;
        }
        return returnValue;
    }

    onOpen(): void {
        this.opened.emit();
    }

    onClose(): void {
        this.closed.emit();
    }

    onChange(value: any): void {
        if (Array.isArray(value) && value.length > 1) {
            value = value.filter(
                (lookups, i, lookup) =>
                    lookup.findIndex(
                        (currentLookup) => currentLookup.id === lookups.id,
                    ) === i,
            );
        }
        this.updateValue(value);
    }

    onConfirmClicked(): void {
        this.modalManagementService.closeActiveModal();
        this.onClose();
    }

    onSearch(searchText: string): void {
        this.searchTriggered.emit(searchText);
        this.keyword = searchText;
    }

    onGenerateAndDownloadDocument(entityId: string): void {
        this.generateDocument.emit(entityId);
    }

    onPreviewAvailableDocumentData(lookup: LookupFieldResult): void {
        this.previewAvailableDocumentData.emit(lookup);
    }

    clearField($event: Event): void {
        $event.stopPropagation();
        super.onClear();
    }

    deleteSingle($event: Event, item: any): void {
        $event.stopPropagation();
        this.deleteItem.emit(item);
    }
}
